import type { ProductOption, ProductOptionSource } from "@/app/types/domain";

export function mapProductOption(product: ProductOptionSource): ProductOption {
  return {
    id: product.id || product._id || product.value || product.name || "",
    name: product.name || product.label || product.value || "",
  };
}
